import React, { FC } from 'react'
import { BaseInputComponent, BaseInputProps } from 'Pages/landings/common/components/Input'
import { InputWrapper } from './styled'

export const InputComponent: FC<BaseInputProps> = ({ error, ...props }) => (
	<InputWrapper isError={Boolean(error)} isNotEmpty={Boolean(props.value)}>
		<BaseInputComponent {...props} />
		{error && <div style={{ color: 'red' }}>{error}</div>}
	</InputWrapper>
)
